import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { useEffect } from "react";
import CampaignAttributionPageComponent from "../components/campaignAttribution/CampaignAttributionPage";
import * as campaignAttributionActions from "../redux/actions/campaignAttributionActions";

const CampaignAttributionPageContainer = ({ campaignAttribution, actions, userId }) => {
  useEffect(() => {
    if (!userId) return undefined;
    actions.fetchCampaignAttributionSummary({ userId });
    return undefined;
  }, [actions, userId]);

  return <CampaignAttributionPageComponent campaignAttribution={campaignAttribution} />;
};

const mapStateToProps = (state) => ({
  campaignAttribution: state.campaignAttribution,
  userId: state.catalogReducer?.user?.userId,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(campaignAttributionActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignAttributionPageContainer);
